import { getBridge } from "@/src/lib/bridge";
import { MessageType } from "@/src/lib/bridge/types";

/**
 * 声明「本 WebView 页面命中了某个原生弹层的展示时机」（EDG-433 · Slice N6 · T6.6）。
 *
 * ## 为什么 web 只能"声明"
 *
 * App 内的弹层机制统一在 `kmp-app`（定端见 fe-spec §0.1）。仍留在 WebView 的页面
 * （`EdWebPages.nativeRouteFor` 里 `else -> null` 的那些：brief 卡片点进的详情、
 * `/crypto/:id`、`/stock/:id` 等）没法自己弹原生弹层，只能报一声。
 *
 * **裁决权全在原生**：冷却、优先级、频次帽、停留计时、记账，web 一概不判也不记。
 * 原生只回 ack、不回裁决结果 —— web 既然不记账，也就不需要知道弹没弹。
 *
 * ⚠️ 该消息在原生侧归入 `DISPLAY_ONLY_TYPES`：离屏 WebView 发的会被 ack 但不执行，
 * 免得用户早已离开的页面把弹层顶到当前所在的原生页面上。
 */
export interface RequestNativeSurfaceParams {
  /** surface key，如 `"push-optin"`。未注册的 key 原生会静默丢弃并上报，不报错 */
  key: string;
  /** push 引导的 variant，如 `"trigger_1"` */
  variant?: string;
  /** 停留计时（毫秒）。**计时在原生跑** —— WebView 被冻结时 web 侧计时会飘 */
  dwellMs?: number;
  /** 免冷却名单（PRD S1.6）。免判定但仍记曝光 */
  bypassCooldown?: boolean;
  /** 文案插值数据。**必须是扁平对象**（原生用 `logEventParams` 还原，不支持嵌套） */
  payload?: Record<string, string | number | boolean>;
}

export function requestNativeSurface(params: RequestNativeSurfaceParams): void {
  const bridge = getBridge();
  if (!bridge.isInApp()) {
    return;
  }
  // 不 await：原生只回 ack，拿不到也不影响任何 web 侧行为
  void bridge.request(MessageType.REQUEST_NATIVE_SURFACE, params);
}
